import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "cropperjs/dist/cropper.css";
import { useDispatch, useSelector } from "react-redux";
import { updateUserProfile, updateVideoAds } from "../../store/slices/authSlice";
import { toast } from "react-toastify";
import AWS from 'aws-sdk';
import { CLOUDFLARE_BUCKET } from '../../constants';
import { Spinner } from "react-bootstrap";
import ProgressBar from 'react-bootstrap/ProgressBar';

const { accessKeyId, secretAccessKey, bucketName, region, endpoint, bucket_url } = CLOUDFLARE_BUCKET;

const s3Client = new AWS.S3({
  accessKeyId,
  secretAccessKey,
  region,
  endpoint,
});

const VideoModel = ({ show, onClose, video, onUploadSuccess }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { attributes: { videoAds } } = user;
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [videoFileUrl, setVideoFileUrl] = useState(null);

  useEffect(() => {
    if (video) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setVideoFileUrl(e.target.result);
      };
      reader.readAsDataURL(video);
    }
  }, [video]);

  const uploadVideoFile = async () => {
    if (!video) {
      toast.error("Please upload a video file!");
      return;
    }

    setIsUploading(true);
    setProgress(0);

    const uniqueFileName = `${Date.now()}_${video.name}`;
    const uploadParams = {
      Bucket: bucketName,
      Key: uniqueFileName,
      Body: video,
      ContentType: video.type,
      ACL: "public-read",
    };

    try {
      const uploadPromise = s3Client.upload(uploadParams)
        .on('httpUploadProgress', (progressEvent) => {
          if (progressEvent.total) {
            const percentageUploaded = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
            setProgress(percentageUploaded);
          }
        })
        .promise();

      const response = await uploadPromise;
      const videoUrl = `${bucket_url}/${response.Key || response.key}`;
      
      // Generate a video identifier based on the file name
      const videoIdentifier = video.name.replace(/\.[^/.]+$/, ""); // Remove file extension
      
      // Call the success callback instead of directly dispatching
      if (onUploadSuccess) {
        onUploadSuccess(videoUrl, videoIdentifier);
      } else {
        // Get existing videos or initialize empty array
        const existingVideos = videoAds?.videos || [];
        const isForStation = user?.attributes?.isOwner == false ? true : false;
        
        // Add new video to existing videos array
        const updatedVideos = [
          ...existingVideos,
          { video: videoUrl, link: '', videoIdentifier: videoIdentifier }
        ];
        
        dispatch(updateVideoAds({
          values: { videoAds: { videos: updatedVideos } },
          message: "Video uploaded successfully!",
          isForStation
        }));
        onClose();
      }

    } catch (error) {
      console.error('Error uploading video:', error);
      toast.error("Failed to upload video.");
    } finally {
      setIsUploading(false);
      setProgress(0);
      // Don't call onClose here if we're using onUploadSuccess
      // The parent component will handle closing the modal
      if (!onUploadSuccess) {
        onClose();
      }
    }
  };

  return (
    <Modal show={show} size="lg" onHide={onClose} centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Upload Video</Modal.Title>
      </Modal.Header>
      
        <div className="adjust-banner-container">
          <div className="adjust-banner-title pb-4">Preview</div>
          {videoFileUrl && (
            <video src={videoFileUrl} controls style={{ width: "100%", maxHeight: "300px" }} />
          )}
          
          {isUploading && (
            <div className="mt-3">
              <ProgressBar now={progress} label={`${progress}%`} />
            </div>
          )}
        </div>

      <Modal.Footer>
        <button 
          type="button" 
          className="btn btn-secondary" 
          onClick={onClose} 
          disabled={isUploading}
        >
          Cancel
        </button>
        <button 
          type="button" 
          className="btn btn-primary" 
          onClick={uploadVideoFile} 
          disabled={isUploading}
        >
          {isUploading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Uploading...
            </>
          ) : (
            "Upload"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default VideoModel;